import { hasJumpLinks, initJumpLinks } from "@solvari/components";
import { handleFloatingPromise } from "@solvari/utils";

import { initDynamicSidebarTitle } from "@/scripts/components/dynamicSidebarTitle.ts";
import { initFormJumplinks } from "@/scripts/components/formJumplinks.ts";
import { initReviews } from "@/scripts/solvari/components/footerReviews.ts";
import { stickyMenuDesktop } from "@/scripts/solvari/components/sticky-menu-desktop/stickyMenuDesktop.ts";

import { initExpertSite } from "./expertSite";

import "./components/accordion.js";
import "./components/novasole.js";
import "./components/sidebarCta.js";

import "../styles/solvari.css";

// Owns its jumplink menu → initJumpLinks instead of moveJumplinks, reported as hasJumpLinks.
handleFloatingPromise(
  initExpertSite({
    afterAbTesting: () => {
      stickyMenuDesktop();
      initFormJumplinks();
    },
    beforeAbTesting: () => {
      initReviews();
      initJumpLinks();
      initDynamicSidebarTitle();
    },
    siteAttributes: { hasJumpLinks },
  }),
);
